export default "__VITE_ASSET__C$vaCqFs__"